import {createContext} from "react";
import type {IUser} from "../models/IUser.ts";
import type {IAccountPermission} from "../sitemap/apiendponts.ts";
import {PermissaoType} from "@assets/models/PermissaoEnum.ts";

type AuthContextType = {
	isAuthenticated: boolean,
	user?: IUser
	token?: string
	permissions: IAccountPermission[]
	login: (user: { username: string, password: string }) => Promise<void>
	logout: () => void,
	refreshPermissions: () => Promise<void>,
	hasPermission: (permission: { modulo: PermissaoType["modulo"], tipo?: PermissaoType["tipo"], acao?: string } | { modulo: PermissaoType["modulo"], tipo?: PermissaoType["tipo"], acao?: string }[]) => boolean
}

export const AuthContext = createContext<AuthContextType | null>(null)
